import { Branding } from '../../branding.interface';

export const ACS_BRANDING: Branding = {
  termsAndConditionsURL: 'https://www.acs.co.ke/terms-conditions',
  privacyStatementURL: 'https://www.acs.co.ke/privacy-policy',
  pageTitle: 'Afia Solution Member | Powered by CarePay',
  support: 'url',
  supportURL: 'https://www.acs.co.ke/',
  healthTab: false,
  heidiProviderTab: false,
  providersTab: true,
  freshchat: false,
  bankCodesUrl: 'https://www.kba.co.ke/wp-content/uploads/2023/09/Bank-and-Branches-July-2023v.pdf',
  poweredBySvg: 'carepay-logo.svg',
};
